// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Sidebar_sidebar__205Ji","menu":"Sidebar_menu__nsMnF"};